<template>
<div >
    <ul-layout v-if="business"> 
        <header v-if="business.name" class="w3-container w3-theme-d2">
                    <h6><slot name="headersideleft"></slot>{{business.name}}<slot name="headersideright"></slot></h6>
        </header>
        <businesses-layout-item v-if="business.shortname">{{business.shortname}}</businesses-layout-item>        
        <businesses-layout-item class="w3-tiny" v-if="business.address">{{business.address}}</businesses-layout-item>
        <businesses-layout-item v-if="business.phone"><b>Cell</b>:{{business.phone}}</businesses-layout-item>
        <businesses-layout-item v-if="business.phone2"><b>Phone</b>:{{business.phone2}}</businesses-layout-item>
        <businesses-layout-item v-if="business.email"><p>
          <b>Email</b>:{{business.email}}</p></businesses-layout-item>
        <businesses-layout-item v-if="business.website">{{business.website}}</businesses-layout-item>        
        <businesses-layout-item v-if="business.pwa && business.pwa.openhours">{{business.pwa.openhours}}</businesses-layout-item>              
                 
    </ul-layout>   
</div>
</template>
<script>
export default {      
  props:["business"]
};
</script>
 


// WEBPACK FOOTER //
// src/components/shared/controls/layouts/BusinessInfoLayout.vue